export const MODAL = {
	SET_MODAL_OPEN : "SET_MODAL_IS_OPEN",
	SET_CLOSE_MODAL: "SET_CLOSE_MODAL"
}

export const LANGUAGE = {
	SET_LANGUAGE: 'SET_LANGUAGE'
}
